import { throwIfMissingEnvVar } from 'config/envVars/helpers';

export const API_ENDPOINT_FULL_URL = `${throwIfMissingEnvVar(
  'PLATGEN_CLIENT_API_ENDPOINT',
  process.env.PLATGEN_CLIENT_API_ENDPOINT
)}/api/v1/ClientGateway/proxy_service_call`;

export const PLATGEN_SPA_BASE_URL = process.env.PLATGEN_SPA_BASE_URL || '';
